import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search__wrapper" }
const _hoisted_2 = { class: "search__actions" }
const _hoisted_3 = { class: "search__page-title" }
const _hoisted_4 = { class: "search__content" }
const _hoisted_5 = {
  key: 0,
  class: "search__content__zero-hits"
}
const _hoisted_6 = {
  key: 1,
  class: "search__content__error"
}

import { ref, computed, onMounted, watch } from "vue";

import { freeze, unfreeze } from "@motillo/ui-scroll-freeze";

import useContext from "@/composables/useContext";
import useWebsiteTexts from "@/composables/useWebsiteTexts";
import useSearch from "@/composables/useSearch";
import useEventListener from "@/composables/useEventListener";
import { deviceWidths } from "../../constants";

import CloseIcon from "@/components/icons/CloseIcon.vue";
import SearchBar from "@/components/search/SearchBar.vue";
import SearchResult from "@/components/search/SearchResult.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Search',
  setup(__props) {

const { route } = useContext();
const { websiteText } = useWebsiteTexts();
const { searchQuery, error, searchResult, clearSearch } = useSearch();
const { useEmitterEventListener } = useEventListener();

const isOpen = ref(false);
const searchEl = ref(null);

const zeroHitsCaption = computed(() => {
  if (searchQuery.value && searchResult.value?.products?.length === 0) {
    return websiteText("search__no_hits_caption").value?.replace("{0}", searchQuery.value);
  }
  return "";
});

function open() {
  freeze("Search");
  isOpen.value = true;
  setTimeout(() => {
    searchEl.value?.classList?.add("open");
  }, 0);
}

function close() {
  unfreeze("Search");
  window && window.innerWidth < deviceWidths.phoneMaxWidth
    ? setTimeout(() => {
        isOpen.value = false;
      }, 250)
    : (isOpen.value = false);

  searchEl.value?.classList?.remove("open");
  clearSearch();
}

onMounted(() => {
  watch(
    () => route.pathname,
    () => {
      close();
    }
  );
});

useEmitterEventListener("Search:Open", open);

return (_ctx: any,_cache: any) => {
  return (isOpen.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "search",
        ref_key: "searchEl",
        ref: searchEl
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(websiteText)("getmygift__search__pagetitle").value), 1),
            _createElementVNode("div", {
              class: "search__close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
            }, [
              _createVNode(CloseIcon, { class: "search__close-icon" })
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(SearchBar, { class: "search__search-bar" }),
            _createVNode(SearchResult),
            (zeroHitsCaption.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(zeroHitsCaption.value), 1))
              : _createCommentVNode("", true),
            (_unref(error))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(websiteText)("getmygift__search__unknownerror").value), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512))
    : _createCommentVNode("", true)
}
}

})